var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo, useMemo, useState, forwardRef } from "react";
import { useUpdateEffect } from "react-use";
import styled from "styled-components";
import useForwardRef from "../../hooks/use-forward-ref";
import Flex from "../templates/flex";
var measurementByDimension = {
    vertical: "height",
    horizontal: "width",
};
var Animated = styled(Flex).attrs({
    column: true,
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transition: ", ";\n  ", ";\n"], ["\n  transition: ",
    ";\n  ", ";\n"])), function (_a) {
    var duration = _a.duration, measurement = _a.measurement;
    return "max-" + measurement + " " + duration + "ms ease-out, opacity " + duration + "ms ease";
}, function (_a) {
    var measurement = _a.measurement, maxDimension = _a.maxDimension;
    return "max-" + measurement + ": " + maxDimension;
});
var Collapsible = forwardRef(function (_a, parentRef) {
    var _b = _a.open, open = _b === void 0 ? false : _b, _c = _a.duration, duration = _c === void 0 ? 150 : _c, children = _a.children, direction = _a.direction, _d = _a.persist, persist = _d === void 0 ? false : _d, rest = __rest(_a, ["open", "duration", "children", "direction", "persist"]);
    duration = process.env.NODE_ENV === "test" ? 0 : duration;
    var _e = useState(open ? "initial" : 0), dimension = _e[0], setDimension = _e[1];
    var _f = useState(open), animatedOpen = _f[0], setAnimatedOpen = _f[1];
    var _g = useForwardRef(parentRef), ref = _g[0], setRef = _g[1];
    useUpdateEffect(function () {
        var nestedRequestId;
        var requestId = requestAnimationFrame(function () {
            setDimension(!open ? ref.current.scrollHeight + "px" : 0);
            nestedRequestId = requestAnimationFrame(function () {
                setDimension(open ? ref.current.scrollHeight + "px" : 0);
            });
        });
        if (open) {
            setAnimatedOpen(true);
        }
        var timeoutId = setTimeout(function () { return (open ? setDimension("initial") : setAnimatedOpen(false)); }, duration);
        return function () {
            cancelAnimationFrame(requestId);
            cancelAnimationFrame(nestedRequestId);
            clearTimeout(timeoutId);
        };
    }, [open]);
    var child = useMemo(function () { return (animatedOpen || persist) && (typeof children === "function" ? children() : children); }, [animatedOpen, persist, children]);
    return (React.createElement(Animated, __assign({ open: open, maxDimension: dimension, measurement: measurementByDimension[direction] || measurementByDimension.vertical, duration: duration, ref: setRef, "data-testid": "collapsible", overflow: dimension === "initial" ? "visible" : "hidden" }, rest), child));
});
export default memo(Collapsible);
var templateObject_1;
